import React from 'react';
import { styled } from '@cp/ds/src/theme';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { getTariffTermLabel } from '@cp/entities/tariff';
import { Tokens, name } from './const';

const TTerm = styled(Box, { name, slot: 'Term' })(({ theme }) => ({
  ...theme.typography.caption,
  textAlign: 'center',
  color: Tokens.TermFG(theme.palette['gray dark']),
}));

export interface TariffTermProps extends BoxProps {
  period?: string;
}
export const TariffTerm: React.FC<TariffTermProps> = ({ period, ...props }) => <TTerm {...props}>{getTariffTermLabel({ period })}</TTerm>;
